import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import DragAndDropBackGroundContainer from "../../../../../edu_lms/components/Game/DragAndDropBackGround/DragAndDropBackGroundContainer";

const DAD_BG = ({ activity, bookId, showResult }) => {
	return (
		<GameContainer data={activity}>
			<DragAndDropBackGroundContainer data={activity} objectId={bookId} showResult={showResult}/>
		</GameContainer>
	);
};
export default DAD_BG;
